<template>
    <div class="fawaterk-checkout py-2">
        <div v-if="loading" class="text-center mx-auto mt-4 mb-8">
            <v-progress-circular indeterminate transition="fade-transition" color="orange darken-2" size="30" width="2"></v-progress-circular>
            <div class="details-text muted--text mt-3">جاري تجهيز صفحة الدفع...</div>
        </div>

        <div v-else-if="opened" class="text-center px-2 py-2">
            <v-icon size="42" color="blue darken-2" class="mb-3">mdi-open-in-new</v-icon>
            <div class="medium-text strong-text--text font-weight-bold mb-2">
                أكمل الدفع في النافذة التي فُتحت
            </div>
            <div class="details-text muted--text mb-5" style="line-height: 1.6;">
                الدفع بيتعمل أونلاين والاعتماد تلقائي، والرصيد بيظهر في محفظتك خلال دقايق بعد إتمام العملية.
                لو الرصيد ما اتحدثش فورًا، ارجع هنا واضغط «تم الدفع — تحديث الرصيد».
            </div>

            <v-btn
                color="primary"
                depressed
                block
                large
                :loading="refreshing"
                class="mb-2"
                @click="confirmPaid"
            >
                <v-icon left>mdi-refresh</v-icon>
                تم الدفع — تحديث الرصيد
            </v-btn>

            <v-btn
                text
                block
                color="muted"
                :disabled="refreshing"
                class="mb-1"
                @click="reopenPayment"
            >
                فتح صفحة الدفع مرة أخرى
            </v-btn>
        </div>
    </div>
</template>

<script>
import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'

export default {
    props: {
        amount: {
            required: true,
        },
    },
    data(){
        return {
            loading: false,
            opened: false,
            refreshing: false,
            checkoutUrl: null,
        }
    },
    computed: {
        ...GlobalComputed,
        normalizedAmount(){
            const value = parseFloat(this.amount);
            return Number.isFinite(value) ? value : null;
        },
    },
    methods: {
        ...GlobalMethods,
        openCheckoutUrl(url){
            this.checkoutUrl = url;
            const popup = window.open(url, '_system');
            // Some browsers block popups; fall back to same-tab navigation.
            if (!popup && typeof window !== 'undefined'){
                window.location.href = url;
                return false;
            }
            return true;
        },
        reopenPayment(){
            if (this.checkoutUrl){
                this.openCheckoutUrl(this.checkoutUrl);
            }
        },
        confirmPaid(){
            if (this.refreshing){
                return;
            }
            this.refreshing = true;
            // Backend credits wallet via webhook after successful payment.
            // Give it a short moment, then ask parent to reload wallet data.
            window.setTimeout(()=>{
                this.refreshing = false;
                this.showMsg('جاري تحديث رصيد المحفظة...', 'info', false, false, 2000);
                this.$emit('done');
            }, 800);
        },
        initOrder(){
            if (this.loading || this.opened){
                return;
            }

            if (this.normalizedAmount === null || this.normalizedAmount <= 0){
                this.showMsg('يرجى إدخال مبلغ صحيح للشحن', 'warning');
                return;
            }

            this.loading = true;

            this.$store.dispatch('createFawaterkOrder', {
                amount: this.normalizedAmount,
            }).then(response=>{
                const url = response && response.data ? response.data.url : null;
                if (!url){
                    throw new Error('FAWATERK_URL_MISSING');
                }

                this.loading = false;
                this.opened = true;
                this.openCheckoutUrl(url);
            }).catch(e=>{
                console.error(e);
                this.loading = false;
                this.opened = false;
                this.showMsg('حدثت مشكلة أثناء تنفيذ الإعداد، حاول مرة أخرى', 'error');
            });
        },
    },
    mounted(){
       this.initOrder();
    }
}
</script>

<style lang="scss" scoped>
.fawaterk-checkout{
    min-height: 140px;
}
</style>
